var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 24.6429H35M19.4444 29.2857H19.4556M23.8889 29.2857H26.1111M15 22.7857C15 22.0469 15.3512 21.3383 15.9763 20.8159C16.6014 20.2935 17.4493 20 18.3333 20H31.6667C32.5507 20 33.3986 20.2935 34.0237 20.8159C34.6488 21.3383 35 22.0469 35 22.7857V30.2143C35 30.9531 34.6488 31.6617 34.0237 32.1841C33.3986 32.7065 32.5507 33 31.6667 33H18.3333C17.4493 33 16.6014 32.7065 15.9763 32.1841C15.3512 31.6617 15 30.9531 15 30.2143V22.7857Z",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.1f930c04ba436a5cc3e6c3456115a510.svg";
export { ForwardRef as ReactComponent };